import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19v-10.5a3.5 3.5 0 1 1 7 0v10.5","key":"svg-0"}],["path",{"d":"M4 13h7","key":"svg-1"}],["path",{"d":"M18 9v6","key":"svg-2"}],["path",{"d":"M21 12h-6","key":"svg-3"}]]

const IconTextIncrease = createReactComponent('outline', 'text-increase', 'TextIncrease', __iconNode);

export default IconTextIncrease;